module.exports = __webpack_public_path__ + "img/logo-occ.fec0cc85.svg";